import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../../components/Loader/Loader';
import ManagePaymentGateway from '../../../components/siteadmin/ManagePaymentGateway/ManagePaymentGateway';

import getAllPaymentMethods from './getAllPaymentMethods.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from "./PaymentGateway.css";

const PaymentGateway = (props) => {

    const { data, data: { loading, getAllPaymentMethods, refetch }, title } = props;
    if (loading) {
        return <Loader type={"text"} />;
    }

    return <ManagePaymentGateway
        getAllPayments={data}
        title={title}
        refetch={refetch}
    />
}

PaymentGateway.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        loading: PropTypes.bool,
        getAllPaymentMethods: PropTypes.any
    })
};

export default compose(
    withStyles(s),
    withQuery(getAllPaymentMethods, {
        options: (props) => ({
            fetchPolicy: 'network-only',
            ssr: false
        })
    })
)(PaymentGateway);
